module.exports = __webpack_public_path__ + "static/remeo-brno-logo-69ab7eed36bf35d726708c4fe11d2b48.png";